// refer below link
//https://www.aliciaramirez.com/2017/01/scrollmagic-for-beginners-tutorial/
var controller = new ScrollMagic.Controller();

var fromLeftTimeline = new TimelineMax();
var fromLeftFrom = TweenMax.from("#cap", 1, {
    y: 50
});
var fromLeftTo = TweenMax.to("#cap", 1, {
    y: 442
});
fromLeftTimeline
    .add(fromLeftFrom)
    .add(fromLeftTo);

    new ScrollMagic.Scene({
        triggerElement: "#slidein2",
        offset: 0,
    })
    .setTween(fromLeftTimeline)
    .duration(800)
    //    .reverse(false)
    //.addIndicators() // add indicators (requires plugin)
    .addTo(controller);

    // Middle 



var fromLeftTimeline2 = new TimelineMax();
var fromLeftFrom2 = TweenMax.from("#mid", 1, {
    y: 150
});
var fromLeftTo2 = TweenMax.to("#mid", 1, {
    y: 330
});
fromLeftTimeline2
    .add(fromLeftFrom2)
    .add(fromLeftTo2);

    new ScrollMagic.Scene({
        triggerElement: "#slidein2",
        offset: 10,
    })
    .setTween(fromLeftTimeline2)
    .duration(800)
    //    .reverse(false)
    //.addIndicators() // add indicators (requires plugin)
    .setPin("#slidein")
    .addTo(controller);

    // middle end 